<mat-form-field>
  <mat-label>{{ resources.AllocationScaniaUnit }}</mat-label>
  <mat-select [(ngModel)]="selected" (ngModelChange)="onChange($event)">
    @for (scaniaUnit of scaniaUnitList | async; track scaniaUnit) {
      <mat-option [value]="scaniaUnit.id">
        {{scaniaUnit.name}} - {{scaniaUnit.description}}
      </mat-option>
    }
  </mat-select>
</mat-form-field>